// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3XfAG","containerItemsCenter":"Skeleton_containerItemsCenter__3ltan"};